import { Navigate, Route, Routes } from 'react-router-dom';

import { pwaMediaQuery } from 'app/middleware/visibility/utils/helpers';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useMediaQuery } from 'utils/mediaQuery';
import { useCurrentUser } from 'utils/user';

import { PreferencesBusylight } from '../preferences/views/busylight/preferencesBusylight.view';

import { SettingsIntegrationsView } from './settingsIntegrations.view';
import { settingsIntegrationsApiTokensRoutes } from './views/apiTokens';
import {
  settingsIntegrationsCardsRoutes,
  SettingsIntegrationsCardsView,
} from './views/cards';
import { settingsIntegrationsChatbotsRoutes } from './views/chatbots';
import { settingsIntegrationsJabraRoutes } from './views/jabra';
import { settingsIntegrationsPartnerWidgetRoutes } from './views/partnerWidget';
import { settingsIntegrationsWebformRoutes } from './views/webform';
import { settingsIntegrationsWebhooksRoutes } from './views/webhooks';

const SettingsIntegrationsRoutes = (): JSX.Element => {
  const [isOpenedInPWA] = useMediaQuery(pwaMediaQuery);
  const {
    partnerIntegrationsWidget,
    webUsbJabraIntegration,
    personalSettingsRevamp,
  } = useFeatureFlag([
    'partner-integrations-widget',
    'web-usb-jabra-integration',
    'personal-settings-revamp',
  ]);

  const {
    currentRole: { atLeastAdmin },
  } = useCurrentUser();

  const jabraRoutes =
    webUsbJabraIntegration && isOpenedInPWA
      ? settingsIntegrationsJabraRoutes
      : null;
  // personalSettingsRevamp is temp flag
  const defaultNonAdminRoute = (() => {
    if (!personalSettingsRevamp) return 'busylight';
    if (jabraRoutes) return 'jabra';
    return '';
  })();

  const renderAdminRoutes = () => (
    <Routes>
      <Route path="*" element={<SettingsIntegrationsView />}>
        <Route index element={<SettingsIntegrationsCardsView />} />

        {partnerIntegrationsWidget
          ? settingsIntegrationsPartnerWidgetRoutes
          : null}
        {settingsIntegrationsWebformRoutes}
        {settingsIntegrationsApiTokensRoutes}
        {settingsIntegrationsWebhooksRoutes}
        {settingsIntegrationsCardsRoutes}
        {settingsIntegrationsChatbotsRoutes}
        {jabraRoutes}

        {/* temporary flag */}
        {personalSettingsRevamp ? null : (
          <Route path="busylight" element={<PreferencesBusylight />} />
        )}

        <Route path="*" element={<Navigate to="/settings/integrations" />} />
      </Route>
    </Routes>
  );

  const renderNonAdminRoutes = () => (
    <Routes>
      <Route path="*" element={<SettingsIntegrationsView />}>
        {/* temporary flag */}
        {!personalSettingsRevamp && (
          <>
            <Route path="busylight" element={<PreferencesBusylight />} />
          </>
        )}
        <Route index element={<Navigate to={defaultNonAdminRoute} />} />
        {jabraRoutes}
      </Route>
    </Routes>
  );

  if (!atLeastAdmin) {
    return renderNonAdminRoutes();
  }

  return renderAdminRoutes();
};

export const settingsIntegrationsRoutes = (
  <Route path="integrations/*" element={<SettingsIntegrationsRoutes />} />
);
